export default {
  variants: {
    primary: {
      field: {
        border: '1px solid',
        color: 'var(--colors-jet)',
        borderColor: 'var(--colors-geyser)',
        bg: 'inherit',
        _readOnly: {
          boxShadow: 'none !important',
          userSelect: 'all',
        },
        _disabled: {
          opacity: 0.4,
          backgroundColor: 'rgba(0,0,0,.05)',
          color: 'unset',
          cursor: 'not-allowed',
        },
        _invalid: {
          borderColor: 'var(--colors-error)',
          boxShadow: 'none',
        },
        _focus: {
          zIndex: 1,
          borderColor: 'var(--colors-primary)',
          boxShadow: 'none',
        },
      },
    },
  },
  defaultProps: {
    size: 'md',
    variant: 'primary',
  },
};
